module.exports = __webpack_public_path__ + "static/media/CeraPro-Medium.3d79b52f.ttf";